var module = angular.module('octopusApp.projects');

module.run(function(pluginRegistry) {

  pluginRegistry.registerFeature("Octopus.Features.JsonConfigurationVariables", function(busy, octopusRepository) {
    return {
      title: "JSON configuration variables",
      description: "Replace settings in selected JSON files with variables defined in Octopus.",
      editTemplateUrl: "areas/projects/features/Octopus.Features.JsonConfigurationVariables_edit.html",
      priority: 15,
      editLink: function($scope, element) {
      },
      enable: function(action, step) {
        action.Properties["Octopus.Action.Package.JsonConfigurationVariablesEnabled"] = "True";
      },
      disable: function(action, step) {
        delete action.Properties["Octopus.Action.Package.JsonConfigurationVariablesEnabled"];
        delete action.Properties["Octopus.Action.Package.JsonConfigurationVariablesTargets"];
      }
    };
  });

});




//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/features/Octopus.Features.JsonConfigurationVariables.js
// module id = 525525044642683
// module chunks = 1